import { ref } from 'vue'
import { defineStore } from 'pinia'
import { mylog } from '../extern/logger';

export const useUiStore = defineStore('uiStore', () => {
  
  const uiState = ref({
    showNotificationBanner:false,
    notificationBannerType:'success',
    notificationBannerText:'Connected',
    availableMetrics:{
      illuminance: true,
      medi: true,
      s_cone_edi: true,
      m_cone_edi: true,
      l_cone_edi: true,
      rh_edi: true,
      x_31: true,
      y_31: true,
      x_64: true,
      y_64: true,
      color_fidelity_index_Rf: false,
      cie_1960_ucs_u: true,
      cie_1960_ucs_v: true,
      cie_1976_ucs_u_prime: true,
      cie_1976_ucs_v_prime: true,
      CCT_Ohno2013: true,
      CCT_Robertson1968: false,
      CRI_Ra: true,
      Duv: true,
      s_cone_irradiance: false,
      m_cone_irradiance: false,
      l_cone_irradiance: false,
      rh_irradiance: false,
      mel_irradiance: false,
      s_cone_elr: false,
      m_cone_elr: false,
      l_cone_elr: false,
      rh_elr: false,
      mel_elr: false,
      tm30_CCT_ohno2013: false,
      tm30_Duv: false,
      tm30_color_fidelity_index_Rf: true,
      tm30_gamut_index_Rg: true,
      tm30_Rcs_h1: true,
      tm30_Rf_h1: true,
      ppfd: false,
      Irradiance: true,
      PeakWavelength: true,
      DominantWavelength: false,
    },
    dialogBox:{
      show:false,
      message:'',
      confirmationResolver:''
    },
    userType: 'admin',
    appFocus:{
      visual: true,
      non_visual: true,
      horticultural: true,
      extensive_quality: false,
    },
    oneNmInterpolation: false,
    fiveNmInterpolation: false,
    noInterpolation: true,
    recordRetrievedOnce: false,
    firmwareUpdateInitiated: false,
    currentlyGettingData: false,
    showAlphaOpicIlluminances: true,
    spectralRecon: false,
    jsonModDone:false,
    holdingMeasurement:false,
    saveSpotMeasurements:false,
    DataProcessing:{
      LowResCalibCheckStatus: false,
      HighResCalibCheckStatus: true,
      IllumianceCheckStatus:true,
      AlphaOpicEDICheckStatus:true,
      xyCheckStatus:true,
      CIE1960UCSCheckStatus:true,
      CIE1976UCSCheckStatus:true,
      CCTCheckStatus:true,
      CRICheckStatus:true,
      DuvCheckStatus:true
    }
  });

  const updateShowNotificationBanner = (payload) => {
    uiState.value.showNotificationBanner = payload;
  }

  const updateNotificationBannerType = (payload) => {
    uiState.value.notificationBannerType = payload;
  }

  const updateNotificationBannerText = (payload) => {
    uiState.value.notificationBannerText = payload;
  }

  const updateUserType = (payload) => {
    uiState.value.userType = payload;
  }

  const updateDialogBox = (show, message, confirmationResolver) => {
    mylog('show', show);
    mylog('message', message);
    mylog('confirmationResolver', confirmationResolver);

    if(show != null){
      uiState.value.dialogBox.show = show;
    }
    if(message != null) {
      uiState.value.dialogBox.message = message;
    }
    if(confirmationResolver != null) {
      uiState.value.dialogBox.confirmationResolver = confirmationResolver;
    }
  }

  const updateOneNmInterpolation = (payload) => {
    uiState.value.oneNmInterpolation = payload;
  }
  const updateFiveNmInterpolation = (payload) => {
    uiState.value.fiveNmInterpolation = payload;
  }
  const updateNoInterpolation = (payload) => {
    uiState.value.noInterpolation = payload;
  }

  const updateRecordTableRetrievedOnce = (payload) => {
    uiState.value.recordRetrievedOnce = payload;
  } 

  const updateFirmwareUpdateInitiated = (payload) => {
    uiState.value.firmwareUpdateInitiated = payload;
  }

  const updateCurrentlyGettingData = (payload) => {
    uiState.value.currentlyGettingData = payload;
  }

  const updateSpectralRecon = (payload) => {
    uiState.value.spectralRecon = payload;
  }

  const updateJsonModDone = (payload) => {
    uiState.value.jsonModDone = payload;
  }

  const updateHoldingMeasurement = (payload) => {
    uiState.value.holdingMeasurement = payload;
  }

  const updateSaveSpotMeasurements = (payload) => {
    uiState.value.saveSpotMeasurements = Boolean(payload);
  }

  const updateLowResCalibCheckStatus = (payload) => {
    uiState.value.DataProcessing.LowResCalibCheckStatus = payload;
  }
  
  const updateHighResCalibCheckStatus = (payload) => {
    uiState.value.DataProcessing.HighResCalibCheckStatus = payload;
  }

  const updateIllumianceCheckStatus = (payload) => {
    uiState.value.DataProcessing.IllumianceCheckStatus = payload;
  }

  const updateAlphaOpicEDICheckStatus = (payload) => {
    uiState.value.DataProcessing.AlphaOpicEDICheckStatus = payload;
  }

  const updatexyCheckStatus = (payload) => {
    uiState.value.DataProcessing.xyCheckStatus = payload;
  }

  const updateCIE1960UCSCheckStatus = (payload) => {
    uiState.value.DataProcessing.CIE1960UCSCheckStatus = payload;
  }

  const updateCIE1976UCSCheckStatus = (payload) => {
    uiState.value.DataProcessing.CIE1976UCSCheckStatus = payload;
  }

  const updateCCTCheckStatus = (payload) => {
    uiState.value.DataProcessing.CCTCheckStatus = payload;
  }

  const updateCRICheckStatus = (payload) => {
    uiState.value.DataProcessing.CRICheckStatus = payload;
  }

  const updateDuvCheckStatus = (payload) => {
    uiState.value.DataProcessing.DuvCheckStatus = payload;
  }
  const resetAllUiStore = () => {
    uiState.value = {
      showNotificationBanner:false,
      notificationBannerType:'success',
      notificationBannerText:'Connected',
      availableMetrics:{
        illuminance: true,
        medi: true,
        s_cone_edi: true,
        m_cone_edi: true,
        l_cone_edi: true,
        rh_edi: true,
        x_31: false,
        y_31: false,
        x_64: false,
        y_64: false,
        color_fidelity_index_Rf: false,
        cie_1960_ucs_u: false,
        cie_1960_ucs_v: false,
        cie_1976_ucs_u_prime: false,
        cie_1976_ucs_v_prime: false,
        CCT_Ohno2013: false,
        CCT_Robertson1968: false,
        CRI_Ra: false,
        Duv: false,
        s_cone_irradiance: false,
        m_cone_irradiance: false,
        l_cone_irradiance: false,
        rh_irradiance: false,
        mel_irradiance: false,
        s_cone_elr: false,
        m_cone_elr: false,
        l_cone_elr: false,
        rh_elr: false,
        mel_elr: false,
        tm30_CCT_ohno2013: false,
        tm30_Duv: false,
        tm30_color_fidelity_index_Rf: false,
        tm30_gamut_index_Rg: false,
        tm30_Rcs_h1: false,
        tm30_Rf_h1: false,
        ppfd: false,
        Irradiance: false,
        PeakWavelength: false,
        DominantWavelength: false,
      },
      dialogBox:{
        show:false,
        message:'',
        confirmationResolver:''
      },
      userType: 'admin',
      appFocus:{
        visual: true,
        non_visual: true,
        horticultural: true,
        extensive_quality: false,
      },
      oneNmInterpolation: false,
      fiveNmInterpolation: false,
      noInterpolation: true,
      recordRetrievedOnce: false,
      firmwareUpdateInitiated: false,
      currentlyGettingData: false,
      showAlphaOpicIlluminances: true,
      spectralRecon: false,
      jsonModDone:false,
      holdingMeasurement:false,
      saveSpotMeasurements:false,
      DataProcessing:{
        LowResCalibCheckStatus: false,
        HighResCalibCheckStatus: true,
        IllumianceCheckStatus:true,
        AlphaOpicEDICheckStatus:true,
        xyCheckStatus:true,
        CIE1960UCSCheckStatus:true,
        CIE1976UCSCheckStatus:true,
        CCTCheckStatus:true,
        CRICheckStatus:true,
        DuvCheckStatus:true
      }
   }
  }

  return {
    uiState,
    updateShowNotificationBanner,
    updateNotificationBannerType,
    updateNotificationBannerText,
    updateDialogBox,
    updateUserType,
    updateOneNmInterpolation,
    updateFiveNmInterpolation,
    updateNoInterpolation,
    updateRecordTableRetrievedOnce,
    updateFirmwareUpdateInitiated,
    updateCurrentlyGettingData,
    resetAllUiStore,
    updateSpectralRecon,
    updateJsonModDone,
    updateHoldingMeasurement,
    updateSaveSpotMeasurements,
    updateLowResCalibCheckStatus,
    updateHighResCalibCheckStatus,
    updateIllumianceCheckStatus,
    updateAlphaOpicEDICheckStatus,
    updateCIE1960UCSCheckStatus,
    updateCIE1976UCSCheckStatus,
    updateCCTCheckStatus,
    updateCRICheckStatus,
    updateDuvCheckStatus,
    updatexyCheckStatus
    
  }
});
